// University of Minnesota Twin Cities' undergraduate majors (#2743). Read on
// 2026-10-01 from majors.umn.edu, the university's official Majors and Minors
// site: its list filtered by each college and by program type "Major" gave
// the college groups, and each major's own page gave the degree, written as
// the site writes it ("Bachelor of Science in Business", "Bachelor of Arts or
// Bachelor of Science"). The Interdisciplinary Computing majors list no
// degree on their pages, so theirs is null, and the site files four of them
// under two colleges each, so they appear under both. The "Admissions"
// college filter (exploratory entry) holds no major and is left out. The
// course catalog on coursedog.com is not used: its host fails the page's
// official-source check. The nursing and music flags quote the college
// file's `deadlines` and `music` sources. The KB's majors list was the
// starting point; the official site wins.
const majors = {
    "slug": "university-of-minnesota-twin-cities",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major on UMN Twin Cities' official majors site, grouped by the college that offers it, with the degree it leads to. Interdisciplinary Computing majors shared by two colleges appear under each. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Carlson School of Management",
            "source": {
                "label": "UMN Twin Cities, Majors and Minors (majors.umn.edu)",
                "url": "https://majors.umn.edu/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Business Analytics",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Entrepreneurial Management",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Finance & Risk Management Insurance",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Human Resources and Industrial Relations",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "International Business",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Marketing",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Public & Nonprofit Management",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Supply Chain & Operations Management",
                    "degree": "Bachelor of Science in Business"
                }
            ]
        },
        {
            "name": "College of Biological Sciences",
            "source": {
                "label": "UMN Twin Cities, Majors and Minors (majors.umn.edu)",
                "url": "https://majors.umn.edu/"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Cellular and Organismal Physiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Ecology, Evolution and Behavior",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Genetics, Cell Biology, and Development",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Microbiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Neuroscience",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Plant and Microbial Biology",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Continuing and Professional Studies",
            "source": {
                "label": "UMN Twin Cities, Majors and Minors (majors.umn.edu)",
                "url": "https://majors.umn.edu/"
            },
            "majors": [
                {
                    "name": "Construction Management",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "Health and Wellbeing Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Health Services Management",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "Information Technology Infrastructure",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "Inter-College Program",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Multidisciplinary Studies",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Design",
            "source": {
                "label": "UMN Twin Cities, Majors and Minors (majors.umn.edu)",
                "url": "https://majors.umn.edu/"
            },
            "majors": [
                {
                    "name": "Apparel Design",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Architecture",
                    "degree": "Bachelor of Design in Architecture or Bachelor of Science"
                },
                {
                    "name": "Graphic Design",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Interdisciplinary Computing: Retail Data Science",
                    "degree": null
                },
                {
                    "name": "Interior Design",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "Bachelor of Landscape Architecture"
                },
                {
                    "name": "Product Design",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Retail and Consumer Studies",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "User Experience (UX)",
                    "degree": "Bachelor of Science in UX Design"
                }
            ]
        },
        {
            "name": "College of Education and Human Development",
            "source": {
                "label": "UMN Twin Cities, Majors and Minors (majors.umn.edu)",
                "url": "https://majors.umn.edu/"
            },
            "majors": [
                {
                    "name": "Business and Marketing Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Early Childhood",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Elementary Education Foundations",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Family Social Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Human Resource Development",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Kinesiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Physical Activity and Health Promotion",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Special Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Sport Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Youth Studies",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Food, Agricultural, and Natural Resource Sciences",
            "source": {
                "label": "UMN Twin Cities, Majors and Minors (majors.umn.edu)",
                "url": "https://majors.umn.edu/"
            },
            "majors": [
                {
                    "name": "Agricultural and Food Business Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Agricultural Communication and Marketing",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Agricultural Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Animal Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Applied Economics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Environmental Sciences, Policy and Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Fisheries, Wildlife, and Conservation Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Food Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Forest and Natural Resource Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Nutrition",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Plant Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Sustainable Agriculture and Food Systems",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Sustainable Systems Management",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "UMN Twin Cities, Majors and Minors (majors.umn.edu)",
                "url": "https://majors.umn.edu/"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "African American and African Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "American Indian Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "American Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Art",
                    "degree": "Bachelor of Arts or Bachelor of Fine Arts"
                },
                {
                    "name": "Art History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Arts Education",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Asian and Middle Eastern Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Astrophysics (B.A.)",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Bachelor of Individualized Studies",
                    "degree": "Bachelor of Individualized Studies"
                },
                {
                    "name": "Biology, Society, and Environment",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Chemistry (B.A.)",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Chicano & Latino Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Classical and Near Eastern Religions and Cultures",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Communication Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Computer Science (B.A.)",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Cultural Studies and Comparative Literature",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Dakota Language",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Dance",
                    "degree": "Bachelor of Arts or Bachelor of Fine Arts"
                },
                {
                    "name": "Developmental Psychology",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Earth Sciences (B.A.)",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Economics - Business Economics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Economics - Quantitative",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Environmental Geosciences (B.A.)",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "French and Italian Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "French Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Gender, Women and Sexuality Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Geography",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "German, Scandinavian, Dutch",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Global Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Human Physiology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Individually Designed Interdepartmental",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Interdisciplinary Computing: Computational Linguistics",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Computing: Geographic Information Science",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Computing: Psychology and Computing",
                    "degree": null
                },
                {
                    "name": "Italian Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Journalism",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Linguistics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics (B.A.)",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Media and Information",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Arts or Bachelor of Music",
                    "flag": "The Bachelor of Music and the BA with applied emphasis need a School of Music application and an audition.",
                    "flagSource": "music"
                },
                {
                    "name": "Music Education",
                    "degree": "Bachelor of Music",
                    "flag": "The Bachelor of Music and the BA with applied emphasis need a School of Music application and an audition.",
                    "flagSource": "music"
                },
                {
                    "name": "Music Therapy",
                    "degree": "Bachelor of Music",
                    "flag": "The Bachelor of Music and the BA with applied emphasis need a School of Music application and an audition.",
                    "flagSource": "music"
                },
                {
                    "name": "Ojibwe Language",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Physics (B.A.)",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Religious Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Russian",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Sociology of Law, Criminology, and Justice",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Spanish and Portuguese Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Spanish Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Speech-Language-Hearing Sciences",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Statistical Practice",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Statistical Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Strategic Communication: Advertising and Public Relations",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Studies in Cinema and Media Culture",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Technical Writing and Communication",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Urban Studies",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Science and Engineering",
            "source": {
                "label": "UMN Twin Cities, Majors and Minors (majors.umn.edu)",
                "url": "https://majors.umn.edu/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering and Mechanics",
                    "degree": "Bachelor of Aerospace Engineering and Mechanics"
                },
                {
                    "name": "Astrophysics (B.S.)",
                    "degree": "Bachelor of Science in Astrophysics"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "Bachelor of Biomedical Engineering"
                },
                {
                    "name": "Bioproducts and Biosystems Engineering",
                    "degree": "Bachelor of Bioproducts and Biosystems Engineering"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Chemical Engineering"
                },
                {
                    "name": "Chemistry (B.S.)",
                    "degree": "Bachelor of Science in Chemistry"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "Bachelor of Civil Engineering"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "Bachelor of Computer Engineering"
                },
                {
                    "name": "Computer Science (B.S.)",
                    "degree": "Bachelor of Science in Computer Science"
                },
                {
                    "name": "Data Science",
                    "degree": "Bachelor of Science in Data Science"
                },
                {
                    "name": "Earth Sciences (B.S.)",
                    "degree": "Bachelor of Science in Earth Sciences"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "Bachelor of Electrical Engineering"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "Bachelor of Environmental Engineering"
                },
                {
                    "name": "Environmental Geosciences (B.S.)",
                    "degree": "Bachelor of Science in Environmental Geosciences"
                },
                {
                    "name": "Geoengineering",
                    "degree": "Bachelor of Geoengineering"
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "Bachelor of Industrial and Systems Engineering"
                },
                {
                    "name": "Interdisciplinary Computing: Computational Linguistics",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Computing: Geographic Information Science",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Computing: Neural Engineering",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Computing: Operations and Information Engineering",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Computing: Psychology and Computing",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Computing: Retail Data Science",
                    "degree": null
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "Bachelor of Materials Science and Engineering"
                },
                {
                    "name": "Mathematics (B.S.)",
                    "degree": "Bachelor of Science in Mathematics"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Mechanical Engineering"
                },
                {
                    "name": "Physics (B.S.)",
                    "degree": "Bachelor of Science in Physics"
                }
            ]
        },
        {
            "name": "School of Dentistry",
            "source": {
                "label": "UMN Twin Cities, Majors and Minors (majors.umn.edu)",
                "url": "https://majors.umn.edu/"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "Bachelor of Science in Dental Hygiene"
                }
            ]
        },
        {
            "name": "Medical School",
            "source": {
                "label": "UMN Twin Cities, Majors and Minors (majors.umn.edu)",
                "url": "https://majors.umn.edu/"
            },
            "majors": [
                {
                    "name": "Mortuary Sciences",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "UMN Twin Cities, Majors and Minors (majors.umn.edu)",
                "url": "https://majors.umn.edu/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "Bachelor of Science in Nursing",
                    "flag": "Apply by November 1; decisions come once the whole nursing pool is reviewed.",
                    "flagSource": "deadlines"
                }
            ]
        },
        {
            "name": "College of Pharmacy",
            "source": {
                "label": "UMN Twin Cities, Majors and Minors (majors.umn.edu)",
                "url": "https://majors.umn.edu/"
            },
            "majors": [
                {
                    "name": "Medical Laboratory Sciences",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Public Health",
            "source": {
                "label": "UMN Twin Cities, Majors and Minors (majors.umn.edu)",
                "url": "https://majors.umn.edu/"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "Bachelor of Arts"
                }
            ]
        }
    ]
};

export default majors;
